import PropTypes from 'prop-types';
import { Modal } from '@bevy/bevy-design-system';

export default function BaseModal({
  isOpen = true,
  onClose = () => {},
  closeOnClickOutside = true,
  size = 'medium',
  position = 'middle',
  children,
}) {
  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size={size}
      position={position}
      closeOnClickOutside={closeOnClickOutside}
    >
      {children}
    </Modal>
  );
}

BaseModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  position: PropTypes.oneOf(['top', 'middle', 'bottom']),
  closeOnClickOutside: PropTypes.bool,
  children: PropTypes.node,
};
